import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const MembershipDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Membership"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Membership">
                {getFieldDecorator('membership', {
                 initialValue: data.membership,
                  rules: [{ required: true, message: 'Please input the Membership!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default MembershipDialogForm;
